import { AHIcon, AHText, Box, TouchableBox, useLayoutContext } from "arkh";
import React from "react";
import { useIntlTokens } from "../../components/mobile/useIntlTokens";
import { TodoEditNewPropertyItem } from "arkh/src/cross-platform/Todo/TodoEditNewPropertyItem";
import { graphql, useFragment } from "react-relay";
import {
  LinkedStoreProductItem,
} from "../../components/LinkedContent/LinkedStoreProductItem";
import { Platform, ScrollView, ViewStyle } from "react-native";
import { LINKED_ITEM_CONTAINER_HEIGHT } from "../../components/LinkedContent/LinkedItemContainer";
import { SignalDetailProducts_StoreProducts$key } from "./__generated__/SignalDetailProducts_StoreProducts.graphql";

function T<Item extends { id: string }>(props: {
  onPressProduct: (id: string) => void;
  products: Item[];
  compact: boolean;
  onAddProduct?: () => void;
  renderItem: (
    item: Item,
    index: number,
    maxWidth: ViewStyle["maxWidth"]
  ) => React.ReactNode;
}) {
  const layout = useLayoutContext();
  const intl_tokens = useIntlTokens();

  return (
    <TodoEditNewPropertyItem
      icon="product"
      title={intl_tokens.Products}
      value={
        !props.onAddProduct ? null : Platform.OS === "web" ? (
          <TouchableBox
            style={{
              height: layout.circle.smallMedium,
              borderWidth: 1,
              justifyContent: "center",
            }}
            borderColor="border-primary"
            spaceHorizontal="small"
            cornerRadius="medium"
            onPress={props.onAddProduct}
          >
            <AHText selectable={false}>{intl_tokens.AddProduct}</AHText>
          </TouchableBox>
        ) : (
          <TouchableBox
            style={{
              justifyContent: "center",
            }}
            cornerRadius="medium"
            onPress={props.onAddProduct}
          >
            <AHIcon type="add" color="text-washed" />
          </TouchableBox>
        )
      }
    >
      {Platform.OS === "web" ? (
        <Box
          style={{
            paddingRight: layout.space.medium,
            paddingBottom: layout.space.medium,
            flexDirection: "row",
            justifyContent: "flex-end",
            flexWrap: "wrap",
            marginLeft: -layout.space.medium,
            marginRight: -layout.space.medium,
          }}
        >
          {props.products.map((product, index) => (
            <Box spaceTop="medium" spaceLeft="medium" key={product.id}>
              {props.renderItem(product, index, undefined)}
            </Box>
          ))}
        </Box>
      ) : props.products.length < 3 && props.compact ? (
        <>
          {props.products.map((product, index) => (
            <Box spaceTop="medium" key={product.id}>
              {props.renderItem(product, index, "100%")}
            </Box>
          ))}
        </>
      ) : (
        <ScrollView
          horizontal
          style={{
            marginBottom: -layout.space.medium,
            marginHorizontal: -layout.space.medium,
          }}
          contentContainerStyle={{
            paddingHorizontal: layout.space.medium,
          }}
        >
          <Box
            style={{
              paddingRight: layout.space.medium,
              paddingBottom: layout.space.medium,
              flexDirection: "column",
              justifyContent: "flex-start",
              flexWrap: "wrap",
              marginLeft: -layout.space.medium,
              marginRight: -layout.space.medium,
              height:
                props.products.length < 3
                  ? LINKED_ITEM_CONTAINER_HEIGHT + layout.space.medium * 2
                  : LINKED_ITEM_CONTAINER_HEIGHT * 2 + layout.space.medium * 3,
              flexShrink: 1,
            }}
          >
            {props.products.map((product, index) => (
              <Box spaceTop="medium" spaceLeft="medium" key={product.id}>
                {props.renderItem(product, index, 200)}
              </Box>
            ))}
          </Box>
        </ScrollView>
      )}
    </TodoEditNewPropertyItem>
  );
}

export function SignalDetailProducts(props: {
  onPressProduct: (id: string) => void;
  products: SignalDetailProducts_StoreProducts$key;
  onAddProduct?: () => void;
  unlinkProduct?: (id: string) => void;
  todoId: string;
  compact: boolean;
}) {
  const products = useFragment(
    graphql`
      fragment SignalDetailProducts_StoreProducts on StoreProduct
      @relay(plural: true) {
        id
        ...LinkedStoreProductItem_StoreProduct
      }
    `,
    props.products
  );
  return (
    <T
      compact={props.compact}
      onAddProduct={props.onAddProduct}
      onPressProduct={props.onPressProduct}
      products={products.map((product) => product)}
      renderItem={(product, _, maxWidth) => (
        <LinkedStoreProductItem
          onPressProduct={props.onPressProduct}
          unLinkProduct={props.unlinkProduct}
          product={product}
          maxWidth={maxWidth}
        />
      )}
    />
  );
}
